import React, { Component } from "react";
import BottomBar from "../../components/navbar/BottomBar.js";
import {
  Flex,
  ListSection,
  StyledA,
  StyledLink,
  Container,
  BorderBottom,
  ItemLink,
} from "../../styles/GlobalStyle.js";
import {
  ListHeaderTitle,
  ListSubTitle,
  TopPadding,
  NameStyle,
  DateStyle,
  ListSectionTitle,
  SmallCart,
  ImageBag,
  Cart,
  Quantity,
  TitleLoading,
  ProductPanel,
  ProductPrice,
  BoxLastItem,
  ListSubTitleAbout,
  BoxLanguage,
  BoxBottomBar,
} from "./style/ProductListStyle.js";
import { getCategories } from "./ViewModel/ProductListViewModel.js";
import bagHolder from "../../assets/item-bag-holder_3.png";
import TopBar from "../../components/navbar/TopBar";
import ButtonLanguage from "../../components/ButtonLanguage";
import Property from "../../model/property";
import storeFunction from "../../utils/storeFunction";
import { withTranslation } from "react-i18next";
import { get, find, forEach, isEmpty, replace, isNull, sortBy } from "lodash";
import LoadingIcon from "../../components/LoadingIcon";
import HeaderImage from "../../components/HeaderImage";
import placeholderSquare from "../../assets/placeholder-square.png";

import Box from "@material-ui/core/Box";
import Skeleton from "@material-ui/lab/Skeleton";

const StoreListService = require("../../backend/StoreListService");

async function parseCategoriesList(
  uid,
  expireKey,
  language,
  accessToken,
  pairGuest,
  signIn
) {
  Property.setWebStoreType({
    uid: uid,
    k: expireKey,
    language: language,
    type: "category",
    accessToken: accessToken,
    pairGuest: pairGuest,
    signIn: signIn,
  });
  const puid = Property.getUid();
  let response = await getCategories(puid, uid, expireKey, language);
  return response.data;
}

async function parseStoreList(uid, expireKey, language) {
  const puid = Property.getUid();
  let response = await StoreListService.getStore(
    puid,
    uid,
    expireKey,
    language
  );
  return response.data;
}

function setHomeGlobalBackgroundColor(presets) {
  if (presets) {
    if (!isEmpty(presets.app_webstore_favicon_url)) {
      const favicon = document.getElementById("favicon");
      if (favicon) favicon.href = presets.app_webstore_favicon_url;
      const appleFavicon = document.getElementById("apple-favicon");
      if (appleFavicon) appleFavicon.href = presets.app_webstore_favicon_url;
    }
    const desktopContainer = document.getElementById("desktop-container");
    if (desktopContainer) {
      if (!isEmpty(presets.app_home_webapp_desktop_bg)) {
        desktopContainer.style.backgroundColor =
          presets.app_home_webapp_desktop_bg;
      }
    }
    const root = document.getElementById("root");
    const tabletContainer = document.getElementById("tablet-container");
    const wrapper = tabletContainer ? tabletContainer : root;

    if (wrapper) {
      if (!isEmpty(presets.app_home_global_background_color)) {
        wrapper.style.backgroundColor =
          presets.app_home_global_background_color;
      }
    }
  }
}

async function getMainData(categoryUid, language) {
  const getPropertyResponse = await StoreListService.getStoreByCategory(
    categoryUid,
    language
  );
  const property = getPropertyResponse.data;
  const response = await StoreListService.getPreset(property.uid);
  Property.setWebStoreType({
    uid: property.store.uid,
    language: language,
    type: "store",
  });
  const presets = response.data;
  Property.setPreset(property.uid, presets);
  setHomeGlobalBackgroundColor(presets);
  return property;
}

class ProductList extends Component {
  constructor(props) {
    super(props);

    const { categoryUid } = this.props.match.params;
    const category = Property.getCategory(categoryUid);

    this.state = {
      category: category,
      navbarOpen: false,
      sections: [],
      title: "",
      totalQuantity: 0,
      totalPrice: 0,
      totalMap: {},
      currentRefIndex: 0,
      categoryTopIndex: 0,
      displayOnly: true,
      webStoreType: { uid: "", k: "" },
      scrollingByCategory: false,
      fulfillmentTypeName: "",
    };
    this.categoryRef = [];
  }

  setCategoryData = function (category) {
    const data = category.sections;
    const displayOnly =
      storeFunction.isAvailable(category) ||
      storeFunction.isAvailable(Property.getData().store);
    var totalQuantity = 0;
    var totalPrice = 0;
    let cartItem = Property.getCartItem();
    var totalMap = {};
    if (cartItem && cartItem.length > 0) {
      for (const item of cartItem) {
        const uid = item.uid;
        const itemQuantity = item.item_quantity;
        totalQuantity += itemQuantity;
        const countedPrice = find(item.price_options, (data) => {
          return data.type === "pick_product_price";
        })
          ? item.item_price * (item.item_quantity / item.item_quantity_list)
          : item.item_quantity * item.item_price;
        totalPrice += countedPrice;
        for (const i of data) {
          for (const j of i.products) {
            if (j.uid === uid) {
              j.item_quantity = itemQuantity;
              if (totalMap[uid]) {
                totalMap[uid] += itemQuantity;
              } else {
                totalMap[uid] = itemQuantity;
              }
            }
          }
        }
      }
    }

    forEach(data, (section) => {
      let availableProducts = [];
      forEach(section.products, (product) => {
        if (displayOnly) {
          product.display_only = displayOnly;
        }
        if (storeFunction.availableInDate(product)) {
          availableProducts.push(product);
        }
      });
      section.products = availableProducts;
    });

    this.setState({
      category: category,
      title: category.title,
      sections: data,
      totalQuantity: totalQuantity,
      totalPrice: totalPrice,
      displayOnly,
      totalMap,
    });
  };

  checkOverflowY() {
    const listContainer = document.getElementById("list-container");
    const tabletContainer = document.getElementById("tablet-container");
    const hasOverflowY = (window.innerWidth > 1025);
    const element = hasOverflowY ? listContainer : tabletContainer;
    return element;
  }

  setupScrollListener = () => {
    const element = this.checkOverflowY();
    if (element) {
      element.addEventListener("scroll", this.trackScrolling);
    }
  };
  
  handleResize = () => {
    const element = this.checkOverflowY();
    if (element) {
      element.removeEventListener("scroll", this.trackScrolling);
      element.addEventListener("scroll", this.trackScrolling);
    }
  };

  componentDidMount() {
    document.addEventListener("DOMContentLoaded", () => {
      this.setupScrollListener();
      const element = this.checkOverflowY();
      if (element) {
        element.addEventListener("scroll", this.trackScrolling);
      }
    });
    window.addEventListener("resize", this.handleResize);

    let { categoryId } = this.props.match.params;
    let query = new URLSearchParams(this.props.location.search);
    const accessToken = query.get("access_token");
    const expireKey = query.get("k");
    const platform = query.get("platform");
    const device_type = query.get("device_type");
    const pairGuest = query.get("pair_guest");
    const signIn = query.get("sign_in");

    if (!!categoryId) {
      const category = Property.getCategory(categoryId);
      const language = this.props.i18n.language;

      if (!category || category.sections.length === 0) {
        getMainData(categoryId, language).then(
          function (property) {
            Property.setCurrencyCode(property.currency_code);
            Property.setData(property);

            // Set the navigation title for putting on next page title
            Property.clearPreviousTitle();
            Property.setPreviousTitle(get(property, "store.title", ""));

            const category = Property.getCategory(categoryId);
            const webStoreType = Property.getWebStoreType();
            this.setState({
              webStoreType: {
                uid: get(webStoreType, "uid", this.props.categoryId),
                k: get(webStoreType, "k", expireKey),
                accessToken: get(webStoreType, "accessToken", ""),
                pairGuest: get(webStoreType, "pairGuest", ""),
                signIn: get(webStoreType, "signIn", ""),
                fulfillmentTypeName: get(
                  property,
                  "store.fulfillment_type_name"
                ),
              },
            });
            this.setCategoryData(category);
          }.bind(this)
        );
      } else {
        const webStoreType = Property.getWebStoreType();
        this.setState({
          webStoreType: {
            uid: get(webStoreType, "uid", this.props.categoryId),
            k: get(webStoreType, "k", expireKey),
            accessToken: get(webStoreType, "accessToken", ""),
            pairGuest: get(webStoreType, "pairGuest", ""),
            signIn: get(webStoreType, "signIn", ""),
          },
        });
        this.setCategoryData(category);
      }

      const presets = Property.getPreset();
      setHomeGlobalBackgroundColor(presets);

      return;
    }

    const webStoreType = Property.getWebStoreType();
    this.setState({
      webStoreType: {
        uid: get(webStoreType, "uid", this.props.categoryId),
        k: get(webStoreType, "k", expireKey),
        accessToken: get(webStoreType, "accessToken", ""),
        pairGuest: get(webStoreType, "pairGuest", ""),
        signIn: get(webStoreType, "signIn", ""),
      },
    });

    if (
      expireKey !== Property.getExpireKey() ||
      accessToken !== Property.getAccessToken()
    ) {
      Property.clearCartItem();
    }

    const puid = Property.getUid();
    if (puid !== query.get("puid")) {
      Property.clearCartItem();
    }

    Property.setUid(query.get("puid"));
    this.callPresetList(query.get("puid"));
    Property.setExpireKey(expireKey);
    Property.setAccessToken(accessToken);
    Property.setPairGuest(pairGuest);
    Property.setSignIn(signIn);
    Property.setPlatform(platform);
    Property.setDeviceType(device_type);
    parseCategoriesList(
      this.props.categoryId,
      expireKey,
      this.props.i18n.language,
      accessToken,
      pairGuest,
      signIn
    ).then(
      function (result) {
        Property.setData(result);
        Property.setCurrencyCode(result.currency_code);
        Property.clearPreviousTitle();

        this.setCategoryData(result.category);
      }.bind(this)
    );
  }

  componentWillUnmount = async () => {
    Property.setProductOffset(window.pageYOffset);
    const element = this.checkOverflowY();
    element.removeEventListener("scroll", this.trackScrolling);
  };

  callPresetList = async (puid) => {
    const response = await StoreListService.getPreset(puid);
    const presets = response.data;
    setHomeGlobalBackgroundColor(presets);
    await Property.setPreset(puid, presets);
  };

  handlePreviousTitle(subItem, e) {
    const { category } = this.state;
    let parentNode;
    const dataParent = Property.getData();
    if (dataParent && dataParent.store) {
      parentNode = dataParent.store;
    } else if (dataParent && dataParent.category) {
      parentNode = category;
    } else {
      parentNode = dataParent;
    }
    const insideTimeBased = storeFunction.checkTimeAvailability(
      parentNode,
      subItem
    );
    if (get(subItem, "kind", "") === "url") {
      return;
    }
    if (get(subItem, "kind", "") === "about") {
      e.preventDefault();
      return;
    }
    if (subItem) {
      Property.setProductDetailData(subItem);
      if (!this.state.displayOnly && insideTimeBased.insideTimeBased) {
        if (!isNull(Property.getAccessToken())) {
          if (Property.getPairGuest()) {
            this.isItemSelection(subItem, e);
          } else {
            Property.setPreviousTitle(this.state.title);
          }
        } else {
          this.isItemSelection(subItem, e);
        }
      } else {
        Property.setPreviousTitle(this.state.title);
      }
    } else {
      Property.setPreviousTitle(this.state.title);
    }
  }

  isItemSelection = (subItem, e) => {
    const { category } = this.state;
    const item_selection = subItem.options;
    if (item_selection.length === 0) {
      const uid = subItem.uid;
      const itemPrice = subItem.price;
      const itemName = subItem.title;
      const subTitle = subItem.subtitle;
      const maxQuantity = subItem.max_quantity;
      const updatedAt = subItem.updatedAt;
      const payload = {
        uid,
        item_quantity: 1,
        item_selection: "",
        pos_item_id: 0,
        item_price: itemPrice,
        item_name: itemName,
        item_subtitle: subTitle,
        max_quantity: maxQuantity,
        unpaired_available: subItem.unpaired_available,
        category_unpaired_available: category.unpaired_available,
        updatedAt: updatedAt,
      };
      Property.setCartItem(payload);
      this.refreshCategoryData();
      e.preventDefault();
    } else {
      Property.setPreviousTitle(this.state.title);
    }
  };

  handleSeleted = () => {
    this.setState({
      sections: [],
      displayOnly: true,
    });
    this.categoryRef = [];
    const webStoreType = Property.getWebStoreType();
    if (webStoreType.type === "store") {
      const { categoryId } = this.props.match.params;
      parseStoreList(
        webStoreType.uid,
        webStoreType.k,
        this.props.i18n.language
      ).then(
        function (result) {
          Property.setCurrencyCode(result.currency_code);
          Property.setData(result);
          Property.clearPreviousTitle();
          Property.setPreviousTitle(get(result, "store.title", ""));
          const category = Property.getCategory(categoryId);
          this.setCategoryData(category);
          this.setState({
            fulfillmentTypeName: get(result, "store.fulfillment_type_name"),
          });
        }.bind(this)
      );
    } else if (webStoreType.type === "category") {
      parseCategoriesList(
        webStoreType.uid,
        webStoreType.k,
        this.props.i18n.language,
        webStoreType.accessToken,
        webStoreType.pairGuest,
        webStoreType.signIn
      ).then(
        function (result) {
          Property.setData(result);
          Property.setCurrencyCode(result.currency_code);
          Property.clearPreviousTitle();
          this.setCategoryData(result.category);
          this.setState({
            fulfillmentTypeName: get(result, "store.fulfillment_type_name"),
          });
        }.bind(this)
      );
    }
  };

  refreshCategoryData() {
    const orderInfo = Property.getOrderInfo();
    if (orderInfo.type === "Category") {
      const category = Property.getCategory(orderInfo.uid);
      this.setCategoryData(category);
    } else {
      const { categoryId } = this.props.match.params;
      if (!!categoryId) {
        let category = Property.getCategory(categoryId);
        this.setCategoryData(category);
        return;
      }
    }
  }

  scrollToMyRef = (index) => {
    if (this.categoryRef[index]) {
      const element = this.checkOverflowY();
      element.removeEventListener("scroll", this.trackScrolling);

      this.setState({
        categoryTopIndex: index,
        scrollingByCategory: true,
      });
      Property.setCategoryTopIndex(index);
      const rect = this.categoryRef[index].getBoundingClientRect();
      const isDesktop = window.innerWidth > 1025
      const scrollTop = element.scrollTop;
      const paddingTop = isDesktop ? 100 : 40;
      const offsetTop = rect.top + scrollTop - paddingTop;
      element.scrollTo({
        top: offsetTop,
        left: 0,
        behavior: "smooth",
      });

      setTimeout(() => {
        element.addEventListener("scroll", this.trackScrolling);
        this.setState({ scrollingByCategory: false });
      }, 1000);
    }
  };

  trackScrolling = () => {
    if (!this.state.scrollingByCategory) {
      let temp = [];
      const isDesktop = window.innerWidth > 1025
      const paddingTop = isDesktop ? 100 : 40;
      for (let i = 0; i < this.state.sections.length; i++) {
        const wrappedElement = document.getElementById(`headerList${i}`);
        if (wrappedElement.getBoundingClientRect().top - paddingTop <= 0) {
          temp.push(i);
        } else {
          break;
        }
      }
      if (temp.length > 0) {
        const index = temp[temp.length - 1];
        if (this.state.categoryTopIndex !== index) {
          this.setState({ categoryTopIndex: index });
          Property.setCategoryTopIndex(index);
        }
      }
    }
  };

  handleClick(e) {
    e.preventDefault();
    Property.popPreviousTitle();
    this.props.history.goBack();
  }

  addRefsToCategoryRefs(index, ref) {
    if (this.categoryRef[index] === undefined && ref !== undefined) {
      this.categoryRef[index] = ref;
    }
  }

  bottomBarView() {
    const currencyCode = Property.getCurrencyCode();
    let url = this.props.match.url;
    let categoryId = this.props.categoryId;

    if (!categoryId) {
      categoryId = this.props.match.params.categoryId;
    }

    if (this.state.displayOnly) {
      const prevTitle = Property.getPreviousTitle();
      if (!prevTitle) {
        return (
          <BottomBar
            price={""}
            count={""}
            title={``}
          />
        );
      } else {
        return (
          <BottomBar
            handler={this.handleClick.bind(this)}
            price={""}
            count={""}
            title={`${this.props.t("SELECT_OPTION")}`}
          />
        );
      }
    } else {
      return (
        <BottomBar
          id={"bottom-bar-link"}
          price={Intl.NumberFormat(currencyCode, {
            style: "currency",
            currency: currencyCode,
            currencyDisplay: "code",
          }).format(this.state.totalPrice)}
          count={this.state.totalQuantity.toString()}
          title={this.props.t(
            this.state.fulfillmentTypeName !== "club_events"
              ? "VIEW_BASKET"
              : "CLUB_EVENT_VIEW_MY_ORDER"
          )}
          url={`/categories/${categoryId}/basket`}
          baseUrl={url}
          listTitle={this.state.title}
          handler={() => this.handlePreviousTitle()}
        />
      );
    }
  }

  render() {
    const { category, webStoreType, title, totalMap } = this.state;
    const sections = this.state.sections?.filter(item => item.products.length > 0)
    let url = this.props.match.url;
    const prevTitle = Property.getPreviousTitle();
    let categoryId = this.props.categoryId;
    const preset = Property.getPreset();
    const catalogStatus = Property.getCatalogStatus();
    if (!categoryId) {
      categoryId = this.props.match.params.categoryId;
    }

    const currencyCode = Property.getCurrencyCode();
    const puid = Property.getUid();
    const search = `${puid ? `puid=${puid}` : ""}${
      webStoreType.uid ? `&uid=${webStoreType.uid}` : ""
    }${webStoreType.k ? `&k=${webStoreType.k}` : ""}${
      !isNull(webStoreType.accessToken)
        ? `&access_token=${webStoreType.accessToken}`
        : ""
    }${webStoreType.pairGuest ? `&pair_guest=${webStoreType.pairGuest}` : ""}${
      webStoreType.signIn ? `&sign_in=${webStoreType.signIn}` : ""
    }`;

    let windowWidth = window.innerWidth;
    let windowHeight = (window.innerHeight * 0.4).toFixed(0);
    if (windowWidth > 1280) {
      windowWidth = 1280;
    }
    if (windowWidth > 400) {
      windowHeight = 400;
    }

    return (
      <div>
        {!category ? (
          <>
            <Skeleton
              variant="rect"
              height={Number(windowHeight)}
              animation={false}></Skeleton>
            {[0, 1, 2].map((value) => (
              <Box
                key={value}
                display="flex"
                p={1}>
                <Box
                  p={1}
                  flexShrink={0}>
                  <Skeleton
                    variant="rect"
                    width={120}
                    height={118}
                    animation={false}
                  />
                </Box>
                <Box
                  p={1}
                  width="100%">
                  <Skeleton
                    animation={false}
                    height={30}
                  />
                  <Skeleton
                    animation={false}
                    width="60%"
                    height={30}
                  />
                </Box>
              </Box>
            ))}
            <Flex flex={1}>
              <TitleLoading>
                <LoadingIcon loadingState={true} />
              </TitleLoading>
            </Flex>
            <BoxLanguage />
            <BoxBottomBar />
          </>
        ) : (
          <>
            <TopBar
              title={this.state.title}
              previousUrl={"/store"}
              search={search ? `?${search}` : ""}
              previousTitle={prevTitle ? prevTitle : undefined}
              sections={sections}
              onPress={(index) => this.scrollToMyRef.bind(this, index)}
              categoryTopIndex={this.state.categoryTopIndex}
              productListPage={true}
              currentPage={"productList"}
            />
            {sections && sections.length === 0 ? (
              <Flex flex={1}>
                <TitleLoading>
                  <LoadingIcon loadingState={true} />
                </TitleLoading>
              </Flex>
            ) : (
              <Container
                className={"sectionContent"}
                id="list-container">
                <TopPadding className="lg:hidden" />
                <div className={"sectionContentLandscape"}>
                      {sortBy(sections, ["position", "id"]).map((item, index) => {

                    return (
                      <ListSection
                        key={index}
                        id={`headerList${index}`}>
                        <Flex flex={1}>
                          <ListSectionTitle
                            className={"headerListText"}
                            ref={(ref) => {
                              ref && this.addRefsToCategoryRefs(index, ref);
                            }}
                            app_home_menu_category={
                              preset.app_home_menu_category
                            }>
                            {isNull(item.title) ? "" : item.title.toUpperCase()}
                          </ListSectionTitle>
                          {sortBy(item.products, ["position", "id"]).map(
                            (subItem, index) => {
                              const item = (
                                <>
                                  {index === 0 ? <></> : <BorderBottom />}
                                  <Flex
                                    flex={1}
                                    margin="16px 16px"
                                    container>
                                    {subItem.item_quantity ? (
                                      <SmallCart
                                        app_home_color_secondary={
                                          preset.app_home_color_secondary
                                        }>
                                        <Flex
                                          container
                                          flex={1}
                                          justifyContent={"center"}
                                          margin={"10% 0 0 0"}>
                                          <ImageBag
                                            src={bagHolder}
                                            alt="bag holder"
                                          />
                                        </Flex>
                                        <Flex
                                          container
                                          flex={1}
                                          justifyContent={"center"}>
                                          <Cart
                                            app_home_color_secondary={
                                              preset.app_home_color_secondary
                                            }>
                                            <Quantity>
                                              {totalMap[subItem.uid]}
                                            </Quantity>
                                          </Cart>
                                        </Flex>
                                      </SmallCart>
                                    ) : null}
                                    {subItem.image ? (
                                      <div
                                        style={{
                                          width: "120px",
                                          height: "120px",
                                          borderColor: "brown",
                                          border: totalMap[subItem.uid]
                                            ? `5px solid ${
                                                preset.app_home_color_secondary
                                                  ? preset.app_home_color_secondary
                                                  : "brown"
                                              }`
                                            : "0px"
                                        }}>
                                        <HeaderImage
                                          image={subItem.image}
                                          preset={preset}
                                          placeholderRectangle={placeholderSquare}
                                          fixedWidth={120}
                                          fixedHeight={120}
                                        />
                                      </div>
                                    ) : null}
                                    <ProductPanel
                                      flex={1}
                                      margin={
                                        subItem.image
                                          ? "0 0 0 16px"
                                          : "0px 0px 0px 32px"
                                      }>
                                      <ListHeaderTitle
                                        app_home_list_item_title_color={
                                          preset.app_home_list_item_title_color
                                        }
                                        hide={subItem.hide_title}
                                        className={"itemListTextStoreTitle"}>
                                        {Property.getTitleCapital(
                                          subItem.title.toLowerCase()
                                        )}
                                      </ListHeaderTitle>
                                      {get(subItem, "kind", "") !== "about" ? (
                                        subItem.subtitle ? (
                                          <>
                                            <ListSubTitle
                                              className={
                                                "itemListTextStoreSubTitle"
                                              }
                                              haveImage={subItem.image}
                                              app_home_list_item_subtitle_color={
                                                preset.app_home_list_item_subtitle_color
                                              }>
                                              {replace(
                                                subItem.subtitle,
                                                "{chat}",
                                                ""
                                              )}
                                            </ListSubTitle>
                                            {get(subItem, "kind", "") ===
                                            "url" ? (
                                              <p>{subItem.action_url_text}</p>
                                            ) : null}
                                          </>
                                        ) : (
                                          <ListSubTitle
                                            className={
                                              "itemListTextStoreSubTitle"
                                            }
                                            haveImage={subItem.image}
                                          />
                                        )
                                      ) : subItem.subtitle ? (
                                        <ListSubTitleAbout
                                          className={
                                            "itemListTextStoreSubTitle"
                                          }
                                          haveImage={subItem.image}
                                          app_home_list_item_subtitle_color={
                                            preset.app_home_list_item_subtitle_color
                                          }>
                                          {replace(
                                            subItem.subtitle,
                                            "{chat}",
                                            ""
                                          )}
                                        </ListSubTitleAbout>
                                      ) : (
                                        <ListSubTitleAbout
                                          className={
                                            "itemListTextStoreSubTitle"
                                          }
                                          haveImage={subItem.image}
                                        />
                                      )}
                                      {get(subItem, "kind", "") !== "about" &&
                                      get(subItem, "price", 0) > 0 ? (
                                        <ProductPrice
                                          className={"priceRowContent"}>
                                          <Flex
                                            container
                                            alignItems={"center"}
                                            justifyContent="flex-end">
                                            <NameStyle
                                              app_home_list_item_subtitle_color={
                                                preset.app_home_list_item_subtitle_color
                                              }>
                                              {totalMap[subItem.uid]
                                                ? totalMap[subItem.uid] + "x - "
                                                : ""}
                                            </NameStyle>
                                            <DateStyle
                                              className={"itemListTextTitle"}
                                              app_home_list_item_title_color={
                                                preset.app_home_list_item_title_color
                                              }>
                                              {Intl.NumberFormat(currencyCode, {
                                                style: "currency",
                                                currency: currencyCode,
                                                currencyDisplay: "code",
                                              }).format(subItem.price)}
                                            </DateStyle>
                                          </Flex>
                                        </ProductPrice>
                                      ) : (
                                        <></>
                                      )}
                                    </ProductPanel>
                                  </Flex>
                                </>
                              );

                              return get(subItem, "kind", "") !== "about" &&
                                !catalogStatus ? (
                                get(subItem, "kind", "") === "url" ? (
                                  <StyledA
                                    href={get(subItem, "action_url")}
                                    key={subItem.uid}>
                                    {item}
                                  </StyledA>
                                ) : (
                                  <StyledLink
                                    to={{
                                      pathname: `/categories/${categoryId}/products/${subItem.uid}`,
                                      fromProductList: { url },
                                      node: { subItem },
                                      listTitle: { title },
                                    }}
                                    target={
                                      get(subItem, "kind", "") === "url"
                                        ? "_blank"
                                        : ""
                                    }
                                    key={subItem.uid}
                                    onClick={(e) =>
                                      this.handlePreviousTitle(subItem, e)
                                    }>
                                    {item}
                                  </StyledLink>
                                )
                              ) : (
                                <ItemLink key={subItem.uid}>{item}</ItemLink>
                              );
                            }
                          )}
                          <BoxLastItem></BoxLastItem>
                          <BorderBottom thickness={10} />
                        </Flex>
                      </ListSection>
                    );
                  })}
                </div>
              </Container>
            )}
            <ButtonLanguage
              onSelected={() => this.handleSeleted()}
              currentPage="category"
              showButton={isEmpty(sections) ? false : true}
            />
            {!catalogStatus && this.bottomBarView()}
          </>
        )}
      </div>
    );
  }
}

export default withTranslation()(ProductList);
